import React, { useState, useEffect, useRef } from 'react';
import { FiSearch } from 'react-icons/fi';

interface SearchBarProps {
  placeholder?: string;
  onSearch: (query: string) => void;
  delay?: number;
}

const SearchBar: React.FC<SearchBarProps> = ({ placeholder = 'Rechercher...', onSearch, delay = 300 }) => {
  const [value, setValue] = useState('');
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      onSearch(value);
    }, delay);
    return () => clearTimeout(timeoutRef.current);
  }, [value, delay, onSearch]);

  return (
    <div style={{ position: 'relative' }}>
      <FiSearch
        size={16}
        style={{
          position: 'absolute',
          left: '0.75rem',
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'var(--color-text-muted)',
        }}
      />
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        style={{
          width: '100%',
          maxWidth: 320,
          padding: '0.5rem 0.875rem 0.5rem 2.5rem',
          fontSize: 'var(--font-size-sm)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-md)',
          background: 'var(--color-surface)',
          outline: 'none',
          transition: 'border-color var(--transition-fast)',
          fontFamily: 'var(--font-family)',
        }}
        onFocus={(e) => {
          e.target.style.borderColor = 'var(--color-secondary)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = 'var(--color-border)';
        }}
      />
    </div>
  );
};

export default SearchBar;
